unit View.Grupos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewGruposList = class(TForm)
    btNew: TButton;
    GruposDataset: TXDataWebDataSet;
    GruposDatasetid: TIntegerField;
    GruposDatasetaliado_id: TIntegerField;
    GruposDatasetdata_base_id: TIntegerField;
    GruposDatasetnome: TStringField;
    GruposDatasetcodigo_interno: TIntegerField;
    GruposDatasetexcluido: TBooleanField;
    GruposDatasetinclusao: TDateTimeField;
    GruposDatasetalteracao: TDateTimeField;
    GruposDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewGruposList: TFViewGruposList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGruposList }

procedure TFViewGruposList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewGruposList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGruposList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewGruposList, AElementID, Result, @AfterCreate);
end;

procedure TFViewGruposList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewGruposList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewGruposList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      GruposDataset.Connection.Model.DefaultSchema.FindEntityType(GruposDataset.EntitySetName),
      GruposDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewGruposList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('grupos', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    GruposDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewGruposList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.grupos.list.pagination.info');
  btNew := TButton.Create('view.grupos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.grupos.list.table');
  cbPageSize := TComboBox.Create('view.grupos.list.cbPageSize');
  edSearch := TEdit.Create('view.grupos.list.search');
  lcPaginator := TListControl.Create('view.grupos.list.pagination');
  GruposDataset := TXDataWebDataSet.Create(Self);
  GruposDatasetid := TIntegerField.Create(Self);
  GruposDatasetaliado_id := TIntegerField.Create(Self);
  GruposDatasetdata_base_id := TIntegerField.Create(Self);
  GruposDatasetnome := TStringField.Create(Self);
  GruposDatasetcodigo_interno := TIntegerField.Create(Self);
  GruposDatasetexcluido := TBooleanField.Create(Self);
  GruposDatasetinclusao := TDateTimeField.Create(Self);
  GruposDatasetalteracao := TDateTimeField.Create(Self);
  GruposDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  GruposDataset.BeforeLoadDFMValues;
  GruposDatasetid.BeforeLoadDFMValues;
  GruposDatasetaliado_id.BeforeLoadDFMValues;
  GruposDatasetdata_base_id.BeforeLoadDFMValues;
  GruposDatasetnome.BeforeLoadDFMValues;
  GruposDatasetcodigo_interno.BeforeLoadDFMValues;
  GruposDatasetexcluido.BeforeLoadDFMValues;
  GruposDatasetinclusao.BeforeLoadDFMValues;
  GruposDatasetalteracao.BeforeLoadDFMValues;
  GruposDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewGruposList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    GruposDataset.SetParentComponent(Self);
    GruposDataset.Name := 'GruposDataset';
    GruposDataset.EntitySetName := 'Grupos';
    GruposDataset.Connection := DMConnection.ApiConnection;
    GruposDataset.Left := 72;
    GruposDataset.Top := 144;
    GruposDatasetid.SetParentComponent(GruposDataset);
    GruposDatasetid.Name := 'GruposDatasetid';
    GruposDatasetid.FieldName := 'id';
    GruposDatasetid.Required := True;
    GruposDatasetaliado_id.SetParentComponent(GruposDataset);
    GruposDatasetaliado_id.Name := 'GruposDatasetaliado_id';
    GruposDatasetaliado_id.FieldName := 'aliado_id';
    GruposDatasetaliado_id.Required := True;
    GruposDatasetdata_base_id.SetParentComponent(GruposDataset);
    GruposDatasetdata_base_id.Name := 'GruposDatasetdata_base_id';
    GruposDatasetdata_base_id.FieldName := 'data_base_id';
    GruposDatasetdata_base_id.Required := True;
    GruposDatasetnome.SetParentComponent(GruposDataset);
    GruposDatasetnome.Name := 'GruposDatasetnome';
    GruposDatasetnome.FieldName := 'nome';
    GruposDatasetnome.Required := True;
    GruposDatasetnome.Size := 255;
    GruposDatasetcodigo_interno.SetParentComponent(GruposDataset);
    GruposDatasetcodigo_interno.Name := 'GruposDatasetcodigo_interno';
    GruposDatasetcodigo_interno.FieldName := 'codigo_interno';
    GruposDatasetcodigo_interno.Required := True;
    GruposDatasetexcluido.SetParentComponent(GruposDataset);
    GruposDatasetexcluido.Name := 'GruposDatasetexcluido';
    GruposDatasetexcluido.FieldName := 'excluido';
    GruposDatasetinclusao.SetParentComponent(GruposDataset);
    GruposDatasetinclusao.Name := 'GruposDatasetinclusao';
    GruposDatasetinclusao.FieldName := 'inclusao';
    GruposDatasetalteracao.SetParentComponent(GruposDataset);
    GruposDatasetalteracao.Name := 'GruposDatasetalteracao';
    GruposDatasetalteracao.FieldName := 'alteracao';
    GruposDatasetexclusao.SetParentComponent(GruposDataset);
    GruposDatasetexclusao.Name := 'GruposDatasetexclusao';
    GruposDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := GruposDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    GruposDataset.AfterLoadDFMValues;
    GruposDatasetid.AfterLoadDFMValues;
    GruposDatasetaliado_id.AfterLoadDFMValues;
    GruposDatasetdata_base_id.AfterLoadDFMValues;
    GruposDatasetnome.AfterLoadDFMValues;
    GruposDatasetcodigo_interno.AfterLoadDFMValues;
    GruposDatasetexcluido.AfterLoadDFMValues;
    GruposDatasetinclusao.AfterLoadDFMValues;
    GruposDatasetalteracao.AfterLoadDFMValues;
    GruposDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
